import React, { useState, useEffect } from 'react';
import './NewsButton.css';
import { getIndicatorStatus } from '../../api';

const NewsButton = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [indicatorData, setIndicatorData] = useState({ status: true, message: '0' });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadIndicator = async () => {
      try {
        const data = await getIndicatorStatus();
        setIndicatorData(data);
      } catch (err) {
        console.error('Failed to load indicator:', err);
      } finally {
        setLoading(false);
      }
    };
    loadIndicator();
  }, []);

  const toggleModal = () => setIsOpen(prev => !prev);

  const good = {
    title: 'Всё работает стабильно',
    content: (
      <>
      'Сейчас всё работает стабильно, проблем со связью и новых блокировок нет. Если у вас не работает — обратитесь в поддержку{' '}
      <a href="https://t.me/risevpn_help" target="_blank" rel="noopener noreferrer">
          @risevpn_help
      </a>
      </>
    ),
  };

  const bad = {
  title: 'Сейчас наблюдаются проблемы',
  content: (
      <>
        Есть проблемы с соединением, возможна нестабильная работа сервиса, восстанавливаем работу, если вам нужна помощь напишите в поддержку{' '}
        <a href="https://t.me/risevpn_help" target="_blank" rel="noopener noreferrer">
          @risevpn_help
        </a>
      </>
    ),
  };

  const staticBlock = {
    title: 'Как это работает',
    content: 'Здесь мы публикуем статус сети и важные сообщения. Если начнутся блокировки или сбои — обновление появится на этом экране первым.',
  };

  const indicator = indicatorData.status; 
  const message = indicatorData.message; 

  return (
    <>
      <button className="news-button" onClick={toggleModal}>
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M4 4h16v16H4z" />
          <path d="M8 8h8v2H8zM8 12h6v2H8zM8 16h4v2H8z" />
          <path d="M16 8h2v10h-2z" />
        </svg>
        <span className="news-label">News</span>
        <span className={`news-indicator ${indicator ? 'green' : 'red'}`} />
      </button>

      {isOpen && (
        <div className="news-modal-overlay" onClick={toggleModal}>
          <div className="news-modal" onClick={(e) => e.stopPropagation()}>
            <div className="news-modal-header">
              <h2>Новости</h2>
              <button className="news-modal-close" onClick={toggleModal}>×</button>
            </div>
            <div className="news-modal-body">
              {!loading && (
                <>
                  <div className="news-item">
                    <div className="news-item-header">
                      <span className={`news-item-indicator ${indicator ? 'green' : 'red'}`} />
                      <h3 className="news-item-title">{indicator ? good.title : bad.title}</h3>
                    </div>
                    <p className="news-item-content">{indicator ? good.content : bad.content}</p>
                  </div>

                  {message && message !== '0' && (
                    <>
                      <hr className="news-divider" />
                      <p className="news-item-content">
                        <i>{message}</i>
                      </p>
                    </>
                  )}

                  <hr className="news-divider" />

                  <div className="news-item">
                    <h3 className="news-item-title">{staticBlock.title}</h3>
                    <p className="news-item-content">{staticBlock.content}</p>
                  </div>
                </>
              )}
              {loading && (
                <div className="news-loading">Загрузка статуса...</div>
              )}
            </div>
            <div className="news-modal-footer">
              <button className="news-modal-close-button" onClick={toggleModal}>
                Закрыть
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default NewsButton;